import { render, staticRenderFns } from "./PartThree.vue?vue&type=template&id=ed886f64&scoped=true"
import script from "./PartThree.vue?vue&type=script&lang=js"
export * from "./PartThree.vue?vue&type=script&lang=js"
import style0 from "./PartThree.vue?vue&type=style&index=0&id=ed886f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed886f64",
  null
  
)

export default component.exports